import {
  GET_HANDOVERS_REQUEST,
  GET_HANDOVERS_SUCCESS,
  GET_HANDOVERS_ERROR,
  GET_HANDOVER_REQUEST,
  GET_HANDOVER_SUCCESS,
  GET_HANDOVER_ERROR,
  CREATE_HANDOVER_REQUEST,
  CREATE_HANDOVER_SUCCESS,
  CREATE_HANDOVER_ERROR,
  UPDATE_STATUS_REQUEST,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_ERROR,
} from './handoverActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  message: '',
  handovers: [],
  handover: {},
  pagination: {},
};

export default function handoverReducer(state = initialState, action) {
  const { type, payload, isLoading, isSuccess, message } = action;

  switch (type) {
    case GET_HANDOVERS_REQUEST:
      return { ...state, isLoading };
    case GET_HANDOVERS_SUCCESS:
      return { ...state, isLoading, handovers: payload.data, pagination: payload };
    case GET_HANDOVERS_ERROR:
      return { ...state, isLoading, message };
    case GET_HANDOVER_REQUEST:
      return { ...state, isLoading };
    case GET_HANDOVER_SUCCESS:
      return { ...state, isLoading, handover: payload.data };
    case GET_HANDOVER_ERROR:
      return { ...state, isLoading, message };
    case CREATE_HANDOVER_REQUEST:
      return { ...state, isLoading, isSuccess };
    case CREATE_HANDOVER_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case CREATE_HANDOVER_ERROR:
      return { ...state, isLoading, isSuccess, message };
    case UPDATE_STATUS_REQUEST:
      return { ...state, isLoading, isSuccess };
    case UPDATE_STATUS_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case UPDATE_STATUS_ERROR:
      return { ...state, isLoading, isSuccess, message };
    default: {
      return state;
    }
  }
}
